module.exports = __webpack_public_path__ + "static/media/facebook.ce289666.svg";